export default {
  init() {
    // JavaScript to be fired on the about us page

    jQuery(function ($) {
      $(document).ready(function () {

        $('.logo-carousel').slick({
          arrows: true,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 200,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1199,
              settings: {
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 991,
              settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        $(".agbLink").click(function (e) {
          e.preventDefault();
        });

      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js